import React, { useEffect, useState } from "react";
import { AnalyticsPage, MetricStrip, Section } from "@redipos/ui";
import type { ConsoleStatsResponse } from "@redipos/contracts";
import { analyticsApi } from "../api.js";

/**
 * Dashboard ejecutivo — solo números, sin acciones destructivas al lado.
 * El reset de datos de demo vive en el módulo Dev Tools, aislado con su
 * propio permiso (ver docs/analisis/consola-admin-rediseno.md §4.6).
 */
export default function DashboardPage() {
  const [stats, setStats] = useState<ConsoleStatsResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    analyticsApi
      .stats()
      .then(setStats)
      .catch(() => setStats(null))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AnalyticsPage title="Resumen" subtitle="Métricas globales de la plataforma">
      <Section title="Métricas globales">
        <MetricStrip
          items={[
            { key: "tenants", label: "Organizaciones", value: loading ? "—" : stats?.tenantsCount ?? "—" },
            { key: "users", label: "Usuarios", value: loading ? "—" : stats?.usersCount ?? "—" },
            { key: "products", label: "Productos", value: loading ? "—" : stats?.prodsCount ?? "—" },
            { key: "sales", label: "Líneas de venta", value: loading ? "—" : stats?.salesCount ?? "—" },
          ]}
        />
      </Section>
    </AnalyticsPage>
  );
}
